<template>
  <el-dialog
    v-if="warningModal"
    v-model="isWarningModalDisplayed"
    class="warning"
    modal-class="center-with-menu"
    body-class="warning__dialog"
    @close="displayWarningModal(null)">
    <template #header>
      <h3 class="warning__title">
      <font-awesome-icon
        :icon="['fal', 'exclamation-triangle']" />
        {{ $t('comparator.warning.title')}}
      </h3>
    </template>
    <content-warning v-html="warningModal.content" class="warning__body"></content-warning>
    <template #footer>
      <div class="warning__footer">
        <el-button v-if="warningModal.cancel"
                  @click="displayWarningModal(null)">{{ $t('base.cancel') }}</el-button>
        <el-button
          class="el-button--warning warning__footer__next"
          @click="close">
          {{ $t('comparator.warning.button')}}
          <font-awesome-icon icon="angle-right" class="warning__footer__next--icon" />
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>
<script>
import { mapActions, mapState } from 'pinia';
import { useConfigStore } from '@/stores';
import ContentWarning from '@/utils/components/ContentWarning.vue';

export default {
  name: 'warningModal',
  components: {
    ContentWarning,
  },
  computed: {
    ...mapState(useConfigStore, ['warningModal', 'isWarningModalDisplayed']),
  },
  methods: {
    ...mapActions(useConfigStore, ['displayWarningModal']),
    close() {
      const warningModal = this.warningModal;
      this.displayWarningModal(null);
      if (!warningModal) {
        return;
      }
      if (warningModal.action) {
        warningModal.action();
      }
      if (warningModal.next) {
        this.$router.push({
          name: warningModal.next,
          params: {
            id: warningModal.offer.id,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss">
.warning {
  margin-top: 5vh !important;
  width: 90%;

  @include breakpoint(tablet) {
    width: 75%;
  }

  &__title {
    margin-top: 0;
    margin-bottom: 0;
    color: var(--nxt-color-warning);
  }
  &__footer {
    &--text {
      text-align: left;
      font-size: 14px;
      margin-bottom: 20px;
    }
    &__next {
      width: 100%;
      @include breakpoint(tablet) {
        width: auto;
      }
      &--icon {
        margin-left: 6px;
      }
    }
  }

  .el-dialog__body {
    padding-top: 10px;
    padding-bottom: 0;
  }
}
</style>
